const WHITE = '#fff';

const GRAY = {
  GRAY_100: '#f7f7f7', // GRAY_ALABASTER
  GRAY_200: '#f0f2f3', // GRAY_LIGHT / DISABLED
  GRAY_300: '#e5e5e5', // GRAY_MERCURY
  GRAY_400: '#a7a7a7', // GRAYISH
  GRAY_500: '#919191', // GRAY
  GRAY_600: '#666',
  GRAY_700: '#484849', // GRAY_MEDIUM
  GRAY_800: '#3e4149', // GRAY_CHARCOAL
  GRAY_FAFAFA: '#fafafa',
  GRAY_A8A8A8: '#A8A8A8',
  GRAY_CACACA: '#CACACA',
  GRAY_DEDEDE: '#dedede',
  GRAY_F0F0F0: '#f0f0f0',
  GRAY_8E8E8E: '#8e8e8e',
  GRAY_363940: '#363940',
};

const BRAND = {
  BRAND_100: '#f7c9b0',
  BRAND_200: '#f7c9b0',
  BRAND_300: '#f7c9b0',
  BRAND_400: '#faa174',
  BRAND_500: '#ff5500',
  BRAND_FFF4EE: '#fff4ee',
};

const RED = {
  RED_100: '#fff4f0',
  RED_200: '#fff4f0',
  RED_300: '#ff7575',
  RED_400: '#ff7575',
  RED_500: '#dd0000',
  RED_600: '#ffe1e3', // PINK_LIGHT
  RED_700: '#a6494f', // MAROON_LIGHT
  RED_ERROR: '#E02020',
  RED_BASIC: '#F60100',
  RED_FED8D8: '#FED8D8',
  RED_CC0000: '#CC0000',
};

const BLUE = {
  BLUE_100: '#e7f4fc',
  BLUE_200: '#e7f4fc',
  BLUE_300: '#e7f4fc',
  BLUE_400: '#4a90e2', // BLUE
  BLUE_500: '#3082BC',
  BLUE_600: '#e7f4fd', // BLUE_ICE
};

const YELLOW = {
  YELLOW_200: '#fef9e8',
  YELLOW_500: '#f6c923', // GOLDEN_YELLOW
  YELLOW_600: '#cba000',
  YELLOW_700: '#735c0f',
};

const GREEN = {
  GREEN_100: '#E6F5DC',
  GREEN_200: '#E6F5DC',
  GREEN_300: '#00CC00',
  GREEN_400: '#649736',
  GREEN_MINT: '#EDF9F3',
  GREEN_CLOVER: '#00A31B',
  GREEN_500: '#e5f4dc',
  FLOURESCENT_GREEN: '#20C43C',
  GREEN_CEF2D4: '#CEF2D4',
  GREEN_00A81C: '#00A81C',
};

const SEMANTIC = {
  SUCCESS: GREEN.GREEN_300,
  ERROR: RED.RED_500,
  INFO: YELLOW.YELLOW_500,

  PRIMARY: BRAND.BRAND_500,
  BLACK: '#000',
  ORANGE: BRAND.BRAND_500,
  BLUE: BLUE.BLUE_400,
  RED: RED.RED_500,
  GRAY: GRAY.GRAY_500,
  DISABLED: GRAY.GRAY_200,
};

/**
 * @deprecated use @ordermentum/ui-shared/foundations/color
 */
const FUTURO = {
  LIGHT: {
    ROSE: '#DD0000',
    SILVER: '#D5DFE9',
    SMOKE: '#F9F9F9',
    STORM: '#363940',
  },
  DARK: {
    ROSE: '#FF8080',
    SILVER: '#424F72',
    SMOKE: '#080820',
    STORM: '#DEDEDE',
  },
};

export const COLOR = {
  WHITE,
  ...GRAY,
  ...BRAND,
  ...SEMANTIC,
  ...RED,
  ...YELLOW,
  ...BLUE,
  ...GREEN,
  FUTURO,
};

export default COLOR;
